export default __webpack_public_path__ + "static/icon-7-6-d6b33ac9ad0ad5e6c6d0f9e1b32b0a50.png";